export const classes = {
  disabledCursor: 'not-allowed',
  pointerCursor: 'cursor-pointer',
  base: 'size-[38px] rounded-[11px] transition-colors duration-150',
  ghost:
    'bg-transparent text-taupe-2 hover:bg-black/[0.06] hover:text-taupe-3 dark:text-mauve-2 dark:hover:bg-white/[0.06] dark:hover:text-mauve-1',
  secondary:
    'border border-solid border-black/10 bg-white/[0.82] text-taupe-2 hover:bg-grey-2 hover:text-taupe-3 dark:border-white/[0.12] dark:bg-[#332e43]/[0.84] dark:text-mauve-2 dark:hover:bg-white/[0.1] dark:hover:text-mauve-1',
  soft: 'bg-brand-accent/[0.14] text-brand-accent hover:bg-brand-accent/[0.24] dark:bg-brand-accent-dark/[0.14] dark:text-brand-accent-dark dark:hover:bg-brand-accent-dark/[0.24]',
  solid: 'bg-grad text-white hover:brightness-[1.07] dark:bg-grad-dark',
};

export const styles = {
  iconButton: {
    '&.Mui-disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  },
};
